import { render, staticRenderFns } from "./WasteVisualizationMedium.vue?vue&type=template&id=182736d3&scoped=true&"
import script from "./WasteVisualizationMedium.vue?vue&type=script&lang=js&"
export * from "./WasteVisualizationMedium.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualizationMedium.vue?vue&type=style&index=0&id=182736d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182736d3",
  null
  
)

export default component.exports